import ApiService from "../ApiService";

const parametersService = {
  getParameterById(id) {
    id = id || 0
    return ApiService.get(`/parameter/${id}`);
  },

  getParameters(page, PerPage, searchString) {
    return ApiService.get(`/parameter`);
  },


  createParameters(formData) {
    return ApiService.post("/parameter", formData);
  },

};

export default parametersService;
